import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


//import { NgxSpinnerModule } from 'ngx-spinner';
import { AutofocusDirective } from './directive/autofocus.directive';



@NgModule({
  //imports: [CommonModule, NgxSpinnerModule],
  imports: [CommonModule],
  declarations: [AutofocusDirective],
  //exports: [NgxSpinnerModule, AutofocusDirective],
  exports: [AutofocusDirective],
})
export class BaseModule { }
